import axios from '../utils/axios';

const baseUrl = `/api/customerRequirement`;

export const fetchCustomerRequirement = async (crtNumber: string) => {
  const requestUrl = `${baseUrl}/${crtNumber}`;
  const res = await axios.get(requestUrl);
  return res;
};

export const searchCRTNumber = async (
  company: string,
  program: string,
  crtNumber: string,
) => {
  const requestUrl = `${baseUrl}/${company}/${program}/${crtNumber}`;
  const res = await axios.get(requestUrl);
  return res;
};
